import { useCallback } from 'react';
import { paths } from 'ramda';

import { usePortletConfig } from 'js/components/system/Portlet';

export const useGameFilter = () => {
    const [
        filterByAttrs,
        gameTypes
    ] = paths([
        ['gamesConfiguration', 'filterByAttrs'],
        ['componentConfiguration', 'gameTypes']
    ], usePortletConfig());

    return useCallback(gameObj => {
        // If configured in IMS
        if (!gameObj?.gameCode?.length) {
            return false;
        }

        // Filter by game type
        if (gameTypes?.length) {
            const isGameType = gameTypes.toUpperCase().includes(gameObj.gameType.toUpperCase());

            if (!isGameType) {
                return false;
            }
        }

        // Filter by game attributes
        if (filterByAttrs?.length) {
            const isAttrPreset = filterByAttrs.find(attr => {
                const gameAttrs = gameObj.description.toLowerCase().split(',') || [];

                return gameAttrs.includes(attr.toLowerCase());
            });

            if (!isAttrPreset) {
                return false;
            }
        }

        return true;
    }, [filterByAttrs, gameTypes]);
};
